import * as React from 'react';

import { AxiosRequestConfig } from 'axios';
import { MediaImage, MediaImageProps } from 'common/components/MediaImage';
import { Progress } from 'reactstrap';
import { axios } from 'common/api/axios.config';
import { toApiError } from 'common/utils/api';
import IcMedia from 'common/components/svg/IcMedia';

export interface MediaUploadProps {
  id: string;
  slug: string;
  value: string;
  size?: MediaImageProps['size'];
  onChange: (field: string, mediaId: string) => void;
}
export interface MediaUploadState {
  progress: number;
  file?: File;
  error?: string;
}
export class MediaUpload extends React.Component<MediaUploadProps, MediaUploadState> {
  state: MediaUploadState = { progress: -1 };

  handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }
    let file = e.target.files[0];
    this.setState({ file: file });

    let data = new FormData();
    data.append('file', file);

    let config: AxiosRequestConfig = {
      onUploadProgress: (p: any) => {
        this.setState({ progress: Math.round((p.loaded * 100) / p.total) });
      },
    };

    this.setState({ error: undefined, progress: 0 });

    axios.post('/v1/media?slug=' + this.props.slug + '&version=V_200_200_SQ', data, config).then(
      res => {
        this.setState({ error: undefined, progress: -1 });
        this.props.onChange(this.props.id, res.data.path);
      },
      err => {
        this.setState({ error: toApiError(err), progress: -1 });
      }
    );
  };

  handleRemoveImage = () => {
    this.props.onChange(this.props.id, '');
  };

  render() {
    return (
      <div>
        <div>
          <MediaImage
            path={this.props.value}
            size={this.props.size || 'sm'}
            fallback={
              <IcMedia fill="#ccc" height="200" width="200" style={{ padding: '1rem', border: '1px solid #ddd' }} />
              // tslint:disable-next-line:jsx-curly-spacing
            }
          />
          {this.props.value && (
            <a style={{ marginTop: -40 }} className="btn btn-default" role="button" onClick={this.handleRemoveImage}>
              <small>
                <i className="fa fa-times" /> Remove
              </small>
            </a>
          )}
        </div>
        <div style={{ marginTop: 10 }}>
          <label className="custom-file">
            <input type="file" onChange={this.handleFileChange} />
            <span className="custom-file-control" />
          </label>
        </div>
        <div style={{ marginTop: 10 }}>
          {this.state.progress > -1 && <Progress value={this.state.progress} animated={true} striped={true} />}
          {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/MediaUpload.tsx